import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { MdOutlineEventNote } from 'react-icons/md'

import { ResourceList } from '@/Core/UI/CrudResource'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'

import { SystemEventResource } from '../Resources/SystemEventResource'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/** Системні події: стандартна колекція ресурсу без дій у рядку */
const IndexPage = observer(() => {
    const listContext: any = useMemo(
        () =>
            createCrudResourceContext({
                contextType: 'list',
                registryKey: 'Setting.SystemEvents.list',
                resource: SystemEventResource,
                /** Журнал лише для читання: колонка «Дії» не потрібна */
                settings: { tableIsActionsColumnHide: true },
            } as any),
        []
    )

    return <ResourceList crudContext={listContext} registryKey="Setting.SystemEvents.list" />
})

export const pageConfig: IPageConfig = {
    key: 'Setting.SystemEvents',
    route: '/settings/system-events',
    title: 'Системні події',
    icon: <MdOutlineEventNote />,
}

export default IndexPage
